/**
 * Avvia controlli di connettivita periodici verso Supabase.
 * @param updateStatus callback per aggiornare lo stato di rete
 * @returns id dell'intervallo attivato
 */
export function startConnectivityChecks(
  updateStatus: (online: boolean) => void
): ReturnType<typeof setInterval> | undefined {
  const supabaseUrl =
    (import.meta as any).env?.VITE_SUPABASE_URL || process.env.VITE_SUPABASE_URL || '';
  const supabaseAnonKey =
    (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY || '';
  if (!supabaseUrl) return;

  const ping = async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      await fetch(`${supabaseUrl}/rest/v1/`, {
        method: 'HEAD',
        headers: {
          apikey: supabaseAnonKey,
          Authorization: `Bearer ${supabaseAnonKey}`,
        },
        signal: controller.signal,
      });
      clearTimeout(timeout);
      // Una qualsiasi risposta HTTP (anche 4xx/5xx) significa che il server è
      // raggiungibile: siamo online. Solo un fetch che lancia indica offline.
      updateStatus(true);
    } catch {
      clearTimeout(timeout);
      updateStatus(false);
    }
  };

  ping();
  return setInterval(ping, 30000);
}
